import { c as _c } from "react/compiler-runtime";
import { debounce } from "@/utils/debounce";
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";
export const getMarkerSize = (zoom: number) => {
  const size = zoom < 12 ? zoom : zoom < 16 ? zoom * 2 : zoom * 2; // Adjust zoom level to match size mapping
  return size + "px";
};
export function useMapMarkerZoomUpdater() {
  const $ = _c(3);
  const map = useMap();
  const rafRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== map) {
    t0 = () => {
      if (!map) {
        return;
      }
      const initialZoom = map.getZoom();
      if (initialZoom !== undefined) {
        document.documentElement.style.setProperty("--marker-size", getMarkerSize(initialZoom));
      }
      const updateMarkerSize = () => {
        if (rafRef.current) {
          cancelAnimationFrame(rafRef.current);
        }
        rafRef.current = requestAnimationFrame(() => {
          const currentZoom = map.getZoom();
          if (currentZoom !== undefined) {
            document.documentElement.style.setProperty("--marker-size", getMarkerSize(currentZoom));
          }
          rafRef.current = null;
        });
      };
      const debouncedUpdateMarkerSize = debounce(updateMarkerSize, 100);
      const zoomListener = map.addListener("zoom_changed", debouncedUpdateMarkerSize);
      return () => {
        if (zoomListener) {
          zoomListener.remove();
        }
        if (rafRef.current) {
          cancelAnimationFrame(rafRef.current);
        }
      };
    };
    t1 = [map];
    $[0] = map;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}